const emptyArray = Object.freeze<any[]>([])

export const fallbackToEmpty = <T>(arr?: T[] | null): Readonly<T[]> => {
  return arr ?? emptyArray
}
